import { ChangeDetectionStrategy, Component, computed, Injector } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { setAppInjector } from './app-injector';
import { CdkPortalOutletAttachedRef, PortalModule } from '@angular/cdk/portal';
import { RenderComponentToImageService } from 'src/shared/services/render-component-to-image.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, PortalModule, CommonModule],
  template: `
    <router-outlet></router-outlet>
    <div class="pointer-events-none fixed right-[-10000px] top-0 h-svh w-svw ">
      <div class="absolute left-0 top-0 overflow-y-hidden" id="share-portal" [ngStyle]="sharePortalStyles()">
        @let portal = portalInfo(); @if(portal){
        <ng-template [cdkPortalOutlet]="portal.portal" (attached)="portalAttached($event)"></ng-template>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        @apply relative flex size-full flex-col;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  portalInfo = toSignal(this._renderComponentToImage.portal);
  sharePortalStyles = computed(() => {
    const portalInfo = this.portalInfo();
    if (!portalInfo) {
      return { width: '0px', height: '0px' };
    }
    if (portalInfo.size) {
      return { width: `${portalInfo.size.width}px`, height: `${portalInfo.size.height}px` };
    }
    return { width: '100%', height: '100%' };
  });
  constructor(private _injector: Injector, private _renderComponentToImage: RenderComponentToImageService) {
    setAppInjector(this._injector);
  }
  portalAttached(e: CdkPortalOutletAttachedRef): void {
    // This method can be used to handle any logic after the portal is attached
    // For example, you might want to log or perform some action
    if (e && 'instance' in e && e.instance) {
      this._renderComponentToImage.attachedComponent.next(e.instance);
    }
  }
}
